
const utilitarios = {

  ObterDataActual () {
    var today = new Date()
    var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
    return date
  },

  ObterData (today) {
    var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
    return date
  },

  ObterMesActual () {
    var today = new Date()
    var date = (today.getMonth() + 1)
    return date
  },

  converterData(){
    let d = new Date();
    d = new Date(d.getTime() - 3000000);
    // eslint-disable-next-line camelcase
    let date_format_str =
      d.getFullYear().toString() +
      "-" +
      ((d.getMonth() + 1).toString().length === 2
        ? (d.getMonth() + 1).toString()
        : "0" + (d.getMonth() + 1).toString()) +
      "-" +
      (d.getDate().toString().length === 2
        ? d.getDate().toString()
        : "0" + d.getDate().toString()) +
      " " +
      (d.getHours().toString().length === 2
        ? d.getHours().toString()
        : "0" + d.getHours().toString()) +
      ":" +
      ((parseInt(d.getMinutes() / 5) * 5).toString().length === 2
        ? (parseInt(d.getMinutes() / 5) * 5).toString()
        : "0" + (parseInt(d.getMinutes() / 5) * 5).toString()) +
      ":00";
      return date_format_str;
  },

  RetornaDataExpiracao (id) {
    if (id === 1) {
      let date = new Date()
      let newDate = new Date(date.setTime(date.getTime() + 30 * 86400000))
      return this.ObterData(newDate)
    }
    if (id === 2) {
      let date = new Date()
      let newDate = new Date(date.setTime(date.getTime() + 90 * 86400000))
      return this.ObterData(newDate)
    }
    if (id === 3) {
      let date = new Date()
      let newDate = new Date(date.setTime(date.getTime() + 365 * 86400000))
      return this.ObterData(newDate)
    }
  },

  RetornaDias (id) {
    if (id === 1) {
      return 30
    }
    if (id === 2) {
      return 90
    }
    if (id === 3) {
      return 365
    }
  },
  
  

 NumberOfDayLeft(dataFim, dataInicio) {    
    // Converte ambas as datas para objetos Date
    const start = new Date(dataInicio);
    const end = new Date(dataFim);
    
    // Normaliza para UTC (remove efeito de fuso horário)
    const startUTC = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
    const endUTC = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
    
    // Calcula a diferença em dias
    const diff = endUTC - startUTC;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));    
    
    return days > 0 ? days : 0;
},

  descricaoClasse( anoacademico ){

    let anoacademico_ = parseInt(anoacademico)

      switch (anoacademico_) {
        case 1:
          return '10ª Classe'
        case 2:
          return '11ª Classe'
        case 3:
          return '12ª Classe'
        case 4:
          return '13ª Classe'
      
         
      }


  },

  descricaoAnolectivo( anolectivo ){

    let ano_ = parseInt(anolectivo)
    if(ano_ <= 2019)
      return anolectivo
    else
      return anolectivo+'/'+(ano_+1).toString().slice(-2)

  },

  correntDateByUnderstanding () {
    let data = new Date()
    var month = []
    month[0] = 'Janeiro'
    month[1] = 'Fevereiro'
    month[2] = 'Março'
    month[3] = 'Abril'
    month[4] = 'Maio'
    month[5] = 'Junho'
    month[6] = 'Julho'
    month[7] = 'Agosto'
    month[8] = 'Setembro'
    month[9] = 'Outubro'
    month[10] = 'Novembro'
    month[11] = 'Dezembro'
    return data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString() + ' ás ' + data.getHours() + ':' + data.getMinutes() + ':' + data.getSeconds()
  }

}
module.exports = utilitarios
